import React, { useState, useEffect } from "react";
import { useCalendarEvents } from "./calendarEvents";
import { useAppContext } from "../../App"; // Import AppContext
import CalendarEventTable from "./CalendarEventTable"; // Import the table component

const CalendarEventData = ({ styles }) => {
    const { currencyPair } = useAppContext(); // Destructure values from AppContext

    // State for backend pagination
    const [currentPage, setCurrentPage] = useState(1); // Current page
    const eventsPerPage = 10; // Number of events per page

    const { calendarEventData, totalPages, loading, error } = useCalendarEvents(
        currencyPair,
        currentPage,
        eventsPerPage
    );

    // Handlers to update the current page
    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage((prevPage) => prevPage + 1);
        }
    };

    const handlePreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage((prevPage) => prevPage - 1);
        }
    };

    if (loading) return <p>Loading Calendar Events...</p>;
    if (error) return <p style={{ color: "red" }}>{error}</p>;

    return (
        <div style={styles?.container || { padding: "20px" }}>
            <h3>Calendar Event Data</h3>
            {!loading && !error && (
                <>
                    <CalendarEventTable
                        data={calendarEventData}
                        timeZone="UTC" // Specify the timezone as needed
                        styles={styles}
                        currentPage={currentPage}
                        totalPages={totalPages}
                        handlePreviousPage={handlePreviousPage}
                        handleNextPage={handleNextPage}

                    />
                    {/* Pagination Controls */}
                   {/*  <div style={styles?.pagination || { marginTop: "20px", textAlign: "center" }}>
                        <button
                            onClick={handlePreviousPage}
                            disabled={currentPage === 1}
                            style={{ marginRight: "10px" }}
                        >
                            Previous
                        </button>
                        <span>
                            Page {currentPage} of {totalPages}
                        </span>
                        <button
                            onClick={handleNextPage}
                            disabled={currentPage === totalPages}
                            style={{ marginLeft: "10px" }}
                        >
                            Next
                        </button>
                    </div> */}
                </>
            )}
        </div>
    );
};

export default CalendarEventData;
